module.exports = __webpack_public_path__ + "static/media/guide.cb73d7fd.svg";